import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateWarehouseVehicleSetupActions as Actions,
  UpdateWarehouseVehicleSetupRequestAction as RequestAction,
} from 'store/ducks/warehouseVehicleSetups';

export function* updateWarehouseVehicleSetupRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `warehouse-vehicle-setups/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Vínculo com setup de veículo atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
